import React from "react";
interface IconProps {
	fill: string;
	class?: string;
	className?: string;
	height: number;
}


export const PensIcon = (props: IconProps) => (
	<svg fill={props.fill} className={props.class} viewBox="0 0 470 470" width={props.height} height={props.height} >
		<g>
		<path d="M341,200h-28.5v-22.5c0-4.142-3.357-7.5-7.5-7.5h-17.5V55.5c0-0.25-0.013-0.499-0.038-0.747
		c-0.02-0.204-0.054-0.403-0.09-0.602c-0.008-0.042-0.011-0.084-0.019-0.126c-0.103-0.514-0.258-1.01-0.46-1.48l-19.97-47.929
		C265.759,1.821,263.027,0,260,0s-5.759,1.821-6.923,4.615l-19.971,47.931c-0.202,0.47-0.356,0.964-0.459,1.478
		c-0.009,0.046-0.013,0.094-0.021,0.14c-0.035,0.194-0.068,0.389-0.088,0.588c-0.025,0.248-0.038,0.497-0.038,0.747V170h-15V19.5
		C217.5,8.748,208.752,0,198,0h-16c-10.752,0-19.5,8.748-19.5,19.5V170h-15V55.5c0-0.25-0.013-0.499-0.038-0.747
		c-0.02-0.199-0.053-0.394-0.088-0.588c-0.009-0.047-0.012-0.094-0.021-0.14c-0.103-0.514-0.257-1.008-0.459-1.478L126.923,4.615
		C125.758,1.821,123.028,0,120,0s-5.758,1.821-6.923,4.615L93.106,52.546c-0.202,0.47-0.356,0.964-0.459,1.478
		c-0.009,0.046-0.013,0.094-0.021,0.14c-0.035,0.194-0.068,0.389-0.088,0.588C92.513,55.001,92.5,55.25,92.5,55.5V170H75
		c-4.142,0-7.5,3.358-7.5,7.5v285c0,4.142,3.358,7.5,7.5,7.5h230c4.143,0,7.5-3.358,7.5-7.5V410H341c33.911,0,61.5-27.589,61.5-61.5
		v-87C402.5,227.589,374.911,200,341,200z M260,27l8.75,21h-17.5L260,27z M247.5,63h25v107h-25V63z M177.5,48h25v15h-25V48z M182,15
		h16c2.439,0,4.5,2.061,4.5,4.5V33h-25V19.5C177.5,17.061,179.561,15,182,15z M177.5,78h25v92h-25V78z M120,27l8.75,21h-17.5L120,27
		z M107.5,63h25v107h-25V63z M387.5,348.5c0,25.64-20.859,46.5-46.5,46.5h-36c-4.143,0-7.5,3.358-7.5,7.5V455h-215V185h215v22.5
		c0,4.142,3.357,7.5,7.5,7.5h36c25.641,0,46.5,20.86,46.5,46.5V348.5z"/>
	<path d="M115,210c-4.142,0-7.5,3.358-7.5,7.5v30c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-30
		C122.5,213.358,119.142,210,115,210z"/>
	<path d="M115,270c-4.142,0-7.5,3.358-7.5,7.5v145c0,4.142,3.358,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-145
		C122.5,273.358,119.142,270,115,270z"/>
	<path d="M341,240h-28.5v-2.5c0-4.142-3.357-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v135c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5V370
		H341c11.855,0,21.5-9.645,21.5-21.5v-87C362.5,249.645,352.855,240,341,240z M347.5,348.5c0,3.584-2.916,6.5-6.5,6.5h-28.5V255H341
		c3.584,0,6.5,2.916,6.5,6.5V348.5z"/>


		</g>

	</svg >
)


// WEBPACK FOOTER //
// ./src/layout/icons/Pens.tsx